import type { ComponentProps } from "react";

import { SvgSlot } from "@/shared/ui/common";

export const WebIcon = (props: ComponentProps<typeof SvgSlot>) => (
  <SvgSlot {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13 13"
      fill="none"
      stroke="currentColor"
    >
      <path
        d="M11.3019 6.61334C11.3019 7.24392 11.1777 7.86835 10.9364 8.4509C10.695 9.03346 10.3413 9.56281 9.89543 10.0087C9.44953 10.4546 8.92018 10.8083 8.33762 11.0496C7.75506 11.291 7.13064 11.4152 6.50006 11.4152C5.86949 11.4152 5.24506 11.291 4.6625 11.0496C4.0799 10.8083 3.55055 10.4546 3.10467 10.0087C2.65877 9.56281 2.30508 9.03346 2.06376 8.4509C1.82245 7.86835 1.69824 7.24392 1.69824 6.61334C1.69824 5.98277 1.82245 5.35834 2.06376 4.77578C2.30508 4.19318 2.65877 3.66383 3.10467 3.21795C3.55055 2.77205 4.07991 2.41836 4.6625 2.17704C5.24506 1.93573 5.86949 1.81152 6.50006 1.81152C7.13064 1.81152 7.75506 1.93573 8.33762 2.17704C8.92018 2.41836 9.44953 2.77205 9.89543 3.21795C10.3413 3.66383 10.695 4.19319 10.9364 4.77578C11.1777 5.35834 11.3019 5.98277 11.3019 6.61334Z"
        strokeWidth="0.8"
      />
      <path
        d="M8.27439 8.4509C8.37091 7.86835 8.42056 7.24392 8.42056 6.61334C8.42056 5.98277 8.37091 5.35834 8.27439 4.77578C8.17778 4.19319 8.03631 3.66383 7.85798 3.21795C7.67964 2.77205 7.46788 2.41836 7.23489 2.17704C7.00181 1.93573 6.75202 1.81152 6.49983 1.81152C6.24764 1.81152 5.99785 1.93573 5.76477 2.17704C5.53178 2.41836 5.32002 2.77205 5.14168 3.21795C4.96334 3.66383 4.82188 4.19318 4.72527 4.77578C4.62875 5.35834 4.5791 5.98277 4.5791 6.61334C4.5791 7.24392 4.62875 7.86835 4.72527 8.4509C4.82179 9.03346 4.96334 9.56281 5.14168 10.0087C5.32002 10.4546 5.53178 10.8083 5.76477 11.0496C5.99785 11.291 6.24764 11.4152 6.49983 11.4152C6.75202 11.4152 7.00181 11.291 7.23489 11.0496C7.46788 10.8083 7.67964 10.4546 7.85798 10.0087C8.03631 9.56281 8.17778 9.03346 8.27439 8.4509Z"
        strokeWidth="0.8"
      />
      <path d="M1.69824 6.61328H11.3019" strokeWidth="0.8" />
    </svg>
  </SvgSlot>
);
